import type { PerformanceRange, PerformanceThresholds } from '~/features/my-wallet/types/charts'

interface PerformanceRangesInput {
  percentage: number
  thresholds: PerformanceThresholds
  showModelA: boolean
  commercialException: boolean
}

/** Ranges can be empty (from >= to); callers are expected to skip those. */
export function buildPerformanceRanges({ percentage, thresholds, showModelA, commercialException }: PerformanceRangesInput): PerformanceRange[] {
  const { modelB, modelA } = thresholds
  const ranges: PerformanceRange[] = [
    { from: 0, to: Math.min(percentage, modelB), tone: 'model-c' },
    { from: modelB, to: Math.min(percentage, modelA), tone: 'model-b' },
  ]
  if (showModelA)
    ranges.push({ from: modelA, to: percentage, tone: 'model-a' })
  if (commercialException)
    ranges.push({ from: percentage, to: 100, tone: 'waived' })
  return ranges
}
